class LqdIconboxCircleHandler extends elementorModules.frontend.handlers.Base {

  onInit(...args) {

    super.onInit(...args);

    this.handleDestroy();

    this.initSpreadInCircle();
    this.initHover3d();

  }

  getDefaultSettings() {
    return {
      selectors: {
        spreadInCircleElement: '[data-spread-incircle]',
        hover3dElement: '[data-hover3d]',
      }
    }
  }

  getDefaultElements() {
    const selectors = this.getSettings('selectors');
    return {
      $spreadInCircleElement: this.$element.find(selectors.spreadInCircleElement),
      $hover3dElement: this.$element.find(selectors.hover3dElement),
    }
  }

  initHover3d() {

    this.elements.$hover3dElement.liquidHover3d();

  }

  initSpreadInCircle() {

    this.elements.$spreadInCircleElement.liquidIconboxCircle();

  }

  onDestroy() {

    this.handleDestroy();

    super.onDestroy();

  }

  handleDestroy() {

    this.handleHover3dDestroy();
    this.handleSpreadInCircleDestroy();

  }

  handleHover3dDestroy() {

    if ( ! this.elements.$hover3dElement.length ) return;

    const hover3dData = this.elements.$hover3dElement.data('plugin_liquidHover3d');

    if ( hover3dData ) {
      hover3dData.destroy();
    }

  }

  handleSpreadInCircleDestroy() {

    if ( ! this.elements.$spreadInCircleElement.length ) return;

    const spreadInCircleData = this.elements.$spreadInCircleElement.data('plugin_liquidIconboxCircle');

    if ( spreadInCircleData ) {
      spreadInCircleData.destroy();
    }

  }
  
}

export default ($element) => {
  elementorFrontend.elementsHandler.addHandler( LqdIconboxCircleHandler, { $element } );
};